function renderChart(chartId, legendDivId) {



    var chartData1 = [];
    var chartData2 = [];
    var chartData3 = [];
    var chartData4 = [];

    function generateChartData() {
        var xValueStart = 0;



        for (var i = 0; i < 200; i++) {
            var newXValue = xValueStart + i;
            
            if(i==150){var a1 = Math.round(Math.random() * 50) + 300;}
            else{var a1 = Math.round(Math.random() * 50) + 50;}
            
            if(i==150){var a2 = Math.round(Math.random() * 50) + 310;}
            else{var a2 = Math.round(Math.random() * 50) + 15;}
            
            if(i==150){var a3 = Math.round(Math.random() * 50) + 288;}
            else{var a3 = Math.round(Math.random() * 50) + 25;}
            
            if(i==150){var a4 = Math.round(Math.random() * 50) + 320;}
            else{var a4 = Math.round(Math.random() * 50) + 40;}


            chartData1.push({
                xValue: i,
                yValue1: a1,
                yValue2: a2,
                yValue3: a3,
                yValue4: a4



            });
            chartData2.push({
                xValue: i,
                yValue: a2
            });
            chartData3.push({
                xValue: i,
                yValue: a3
            });
            chartData4.push({
                xValue: i,
                yValue: a4
            });
        }
    }

    generateChartData();

    /*  AmCharts.ready(function () {
          var chart = new AmCharts.AmSerialChart();
          chart.dataProvider = chartData1;
          chart.categoryField = "xValue";

          var graph = new AmCharts.AmGraph();
          graph.valueField = "yValue";
          graph.type = "line";
          chart.addGraph(graph);

          chart.write('chartdiv');
      });*/

    var chart = AmCharts.makeChart(
        chartId, {
            "type": "serial",
            "theme": "none",
            "pathToImages": "http://www.amcharts.com/lib/3/images/",
            "dataDateFormat": "YYYY-MM-DD",
            "valueAxes": [{
                "id": "v1",
                "axisAlpha": 0,
                "position": "left"
            }],
            "export": {
                "enabled": true
            },
            "graphs": [{
                    "id": "g1",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": "#FFFFFF",
                    "bulletSize": 5,
                    "hideBulletsCount": 1000,
                    "lineThickness": 2,
                    "title": "Al2SO4",
                    "useLineColorForBulletBorder": true,
                    "valueField": "yValue1"
            },
                {
                    "id": "g2",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": "#00FF00",
                    "bulletSize": 5,
                    "hideBulletsCount": 1000,
                    "lineThickness": 2,
                    "title": "K2SO4",
                    "useLineColorForBulletBorder": true,
                    "valueField": "yValue2"
            },
                {
                    "id": "g3",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": "#00FF00",
                    "bulletSize": 5,
                    "hideBulletsCount": 1000,
                    "lineThickness": 2,
                    "title": "Na2SO4",
                    "useLineColorForBulletBorder": true,
                    "valueField": "yValue3"
            },
                {
                    "id": "g4",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": "#00FF00",
                    "bulletSize": 5,
                    "hideBulletsCount": 1000,
                    "lineThickness": 2,
                    "title": "CaSO4",
                    "useLineColorForBulletBorder": true,
                    "valueField": "yValue4"
        }],
            "categoryField": "xValue",
            "categoryAxis": {
                "parseDates": false,
                "dashLength": 1,
                "minorGridEnabled": true,
                "position": "bottom"
            },
            exportConfig: {
                menuRight: '20px',
                menuBottom: '50px',
                menuItems: [{
                    icon: 'http://www.amcharts.com/lib/3/images/export.png',
                    format: 'png'
          }]
            },
            "dataProvider": chartData1,
            dataSetSelector: {
                position: "left"
            }
        });
    var legend = new AmCharts.AmLegend();
    legend.position = "left";
    legend.align = "center";
    legend.markerType = "square";
    legend.valueText = "aa";
    chart.addLegend(legend, legendDivId);



}
